(function () {
    "use strict";

    cip_StatusDocumentDialog.id = function () {
        return 'documentDialog';
    };

    cip_StatusDocumentDialog.title = function () {
        return 'Add Document';
    };

    cip_StatusDocumentDialog.width = function () {
        return 450;
    };

    cip_StatusDocumentDialog.content = function () {
        return '' +
            '<div class="space-y-8">' +
                '<label id="documentFilePanel">' +
                    '<span class="textLabel">Document</span>' +
                    '<form id="documentFileForm" >' +
                        '<input name="description" type="hidden"/>' +
                        '<input name="privateAsDefined" type="hidden"/>' +
                        '<input id="documentFileName" name="document" class="btn btn-default" type="file" />' +
                    '</form>' +
                '</label>' +
                '<label>' +
                    '<span class="textLabel">Description</span>' +
                    '<textarea class="text" name="documentDescription">' +
                    '</textarea>' +
                '</label>'+
            '</div>';
    };

    cip_StatusDocumentDialog.firstOpen = function () {
    };

    cip_StatusDocumentDialog.success = function () {
    };

    cip_StatusDocumentDialog.unpopulate = function () {
        var document = {};

        document.description = $('#' + cip_StatusDocumentDialog.id() + " textarea[name=documentDescription]").getValue();
        document.privateAsDefined = false;

        $('#documentFileForm input[name=description]').setValue(document.description);
        $('#documentFileForm input[name=privateAsDefined]').setValue("" + document.privateAsDefined);

        return document;
    };
})();